import React from 'react';

import Link from 'gatsby-link';
import { Card } from 'polythene-react';

const apps = [
  {
    path: '/SubFire2Mobile',
    title: 'SubFire 2 Mobile',
    summary:
      'A Progressive Web App Subsonic client for Browsers and Mobile Devices',
  },
  {
    path: '/SubFire2Dash',
    title: 'SubFire 2 Dash',
    summary: 'A Progressive Web App Optimized for Portrait Orientation',
  },
  {
    path: '/SubFire2TV',
    title: 'SubFire 2 TV',
    summary: "A New SubFire Client for Amazon's Fire TV/Stick",
  },
  {
    path: '/SubFire2Timer',
    title: 'SubFire 2 Timer',
    summary: 'A "Toothbrush Timer" Progressive Web App player for mobile',
  },
  {
    path: '/SubFire2Quick',
    title: 'SubFire 2 Quick',
    summary: 'A Simpler Player Modeled After Perisonic',
  },
  {
    path: '/SubFire2Baseline',
    title: 'SubFire 2 Baseline',
    summary: 'An Experimental App for testing new SubFire 2 Features',
  },
]

const developmentApps = [
  {
    path: '/SubFire3PlaylistEditor',
    title: 'SubFire 3 Playlist Editor',
    summary:
      "A 'Desktop' Web Player with Playlist and Radio Station Editing, Stars, and Ratings",
  },
  {
    path: '/SubFire3Mobile',
    title: 'SubFire 3 Mobile',
    summary:
      'A Progressive Web App Subsonic client for Browsers and Mobile Devices',
  },
  {
    path: '/SubFire3Tags',
    title: 'SubFire 3 Tags',
    summary: 'A Desktop editor for ID3 tags and file organizer',
  },
]

const retiredApps = [
  {
    path: '/SubFirePlayer1',
    title: 'SubFire Player 1',
    summary:
      'A full-featured Subsonic client for FireTV, Fire Tablets, Chromebooks, and the Web',
  },
  {
    path: '/SubFireMobile',
    title: 'SubFire Mobile (Legacy)',
    summary: 'A Full-featured Progressive Web App player for mobile',
  },
  {
    path: '/SubFireRadio',
    title: 'SubFire Radio',
    summary: 'A Rules-based Playlist Generation Tool',
  },
]

const subfire5Apps = [
  {
    path: '/SubFire5Demo',
    title: 'SubFire 5 Demo',
    summary: 'An in development Progressive Web App player for mobile and desktop'
  }
]

const AppCard = props => {
  return (
    <div className="grid-50">
      <Card
        className="app-card"
        content={[
          {
            primary: {
              title: (
                <Link
                  className="flow-text"
                  style={{
                    color: 'white',
                  }}
                  to={props.path}
                >
                  {props.title}
                </Link>
              ),
            },
          },
          {
            text: {
              content: (
                <div className="flow-text summary-content">{props.summary}</div>
              ),
            },
          },
        ]}
      />
    </div>
  )
}

const Apps = props => {
  return (
    <div className="app-cardlist grid-70 grid-parent flow-text">
      <h4 className="grid-100">SubFire 5 Apps</h4>
      {subfire5Apps.map(x => (
        <AppCard
          key={x.path}
          title={x.title}
          summary={x.summary}
          path={x.path}
        />
      ))}
      <br />
      <h4 className="grid-100">SubFire 4 Apps</h4>
      <p>Tech note: SubFire 4 was an experiment in moving to a monorepo and attempt to upgrade the system to the latest react,
        storybook, mui, and more...and generally failed. I gave up and started SubFire 5 under a new approach.
      </p>
      <br />
      <h4 className="grid-100">SubFire 3 Apps</h4>
      {developmentApps.map(x => (
        <AppCard
          key={x.path}
          title={x.title}
          summary={x.summary}
          path={x.path}
        />
      ))}
      <br />
      <h4 className="grid-100">SubFire 2 Apps</h4>
      {apps.map(x => (
        <AppCard
          key={x.path}
          title={x.title}
          summary={x.summary}
          path={x.path}
        />
      ))}
      <br />
      <h4 className="grid-100">Retired and Deprecated Apps</h4>
      {retiredApps.map(x => (
        <AppCard
          key={x.path}
          title={x.title}
          summary={x.summary}
          path={x.path}
        />
      ))}
    </div>
  )
}

const Images = props => {
  return (
    <div className="grid-30">
      <img
        src="https://subfiresuite.com/caps/uploads/big/545ab432018969952c0b57b06a67ef6a.png"
        style={{
          paddingTop: 10,
          width: '100%',
          height: 'auto',
          paddingBottom: 20,
        }}
      />
      <img
        src="https://subfiresuite.com/caps/uploads/big/bb54489123c155de275966c3d56f0271.png"
        style={{
          width: '100%',
          height: 'auto',
          paddingBottom: 20,
        }}
      />
      <img
        src="https://subfiresuite.com/caps/uploads/big/1166e7436043130f941bc83e39233839.png"
        style={{
          width: '100%',
          height: 'auto',
          paddingBottom: 20,
        }}
      />
    </div>
  )
}

const IndexPage = () => (
  <div className="index grid-parent">
    <h3 className="grid-100">
      Welcome to the SubFire Suite of Apps for Subsonic
    </h3>
    <div className="grid-100 flow-text">
      SubFire is a suite of applications, including players, playlist editors,
      and more, for the <a href="http://subsonic.org/">Subsonic media server</a>.
    </div>
    <Apps />
    <Images />
    <div
      className="grid-100 privacy-row flow-text"
      style={{
        paddingBottom: 20,
      }}
    >
      SubFire's <a href="/Privacy">Privacy Policy</a>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js